import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';
const { PLAIN_TEXT, DARK_TEXT } = COLORS;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      '& .Mui-disabled': {
        color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      },
    },
  }),
);
